// 記事で使う Lucide アイコンだけを集約する（ツリーシェイクでバンドルを最小化する）。
// 全アイコン(icons バレル)を import すると数千アイコンが入って高速要件に反するため、
// 使用するアイコンのみを列挙し createIcons({ icons }) へ渡す。
// 新しいアイコンを使う場合はここに追記する。HAML 側は data-lucide="kebab-case" で参照する。
import {
  Menu,
  X,
  Check,
  ArrowRight,
  ArrowLeft,
  Sparkles,
  BookOpen,
  BookA,
  Trophy,
  Calculator,
  BarChart3,
  Newspaper,
  List,
  Compass,
  HelpCircle,
  ChevronDown,
  ChevronRight,
  ExternalLink,
  Star,
  Image,
  LayoutDashboard,
} from 'lucide'

export const icons = {
  Menu,
  X,
  Check,
  ArrowRight,
  ArrowLeft,
  Sparkles,
  BookOpen,
  BookA,
  Trophy,
  Calculator,
  BarChart3,
  Newspaper,
  List,
  Compass,
  HelpCircle,
  ChevronDown,
  ChevronRight,
  ExternalLink,
  Star,
  Image,
  LayoutDashboard,
}
